var render = function render(){var _vm=this,_c=_vm._self._c;return _c('club',{attrs:{"id":_vm.$route.params.clubId},on:{"submit":function($event){return _vm.update($event)},"remove":function($event){return _vm.remove($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }